import { createApp } from 'vue'
import { createPinia } from 'pinia'

import { ContainerNaviWelcome } from '@/modules/navi'

const naviApp = createApp(ContainerNaviWelcome)
naviApp.use(createPinia())
naviApp.mount('#navi-app')
